import React from "react";
import { LessonContextProvider, LessonIntl } from "@jelly/lesson";

import * as ui from "@src/lms/jelly/extensions/ui";
import * as components from "@src/lms/jelly/extensions/components";
import * as layouts from "@src/lms/jelly/extensions/layouts";
import * as blocks from "@src/lms/jelly/extensions/blocks";
import { useConfig } from "@src/components/providers/ConfigProvider";

interface JellyProviderProps {
  children: React.ReactNode;
}

export const JellyProvider: React.FC<JellyProviderProps> = ({ children }) => {
  const { lang } = useConfig();

  return (
    <LessonContextProvider ui={ui} components={components} layouts={layouts} blocks={blocks}>
      <LessonIntl locale={lang}>{children}</LessonIntl>
    </LessonContextProvider>
  );
};
